var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSignature = function SvgSignature(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".signature_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.916 16.872a2.473 2.473 0 1 1 4.571 1.88c-.519 1.263-4.167 3.631-4.167 3.631s-.92-4.249-.404-5.511M14.843 18.684l-1.523 3.699",
    className: "signature_svg__a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m14.325 14.683 3.044-7.394 3.698 1.522-3.043 7.394zM19.651 1.739a2 2 0 0 0-2.61 1.089L14 10.225",
    className: "signature_svg__a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.651 1.74a2 2 0 1 1 3.7 1.521L21.067 8.81l-3.7-1.521ZM.5 23.174a4.4 4.4 0 0 1 2.933-1.1c1.758 0 4.864 2.847 7.7.5",
    className: "signature_svg__a"
  })));
};
export default SvgSignature;